import { Sort } from './sort';
/**
 * Sort domain of x scale of mark groups by groups.
 */
export const SortX = (options = {}) => {
    return Sort(Object.assign(Object.assign({}, options), { channel: 'x' }));
};
SortX.props = {};
//# sourceMappingURL=sortX.js.map